<template>
  <container :class="['theme-colors-display']">
    <flex-col :span="24">
      <flex>
        <flex-col :span="3" v-for="(value, color) in colors" :key="color" md6 sm12 xs24 v-if="colors">
          <container :class="['p-2']">
            <btn block :bold="false" :uppercase="false" size="xs" :bg-color="color" color="white" :bg-color-lightness="500" :title="value">
              <code v-html="label(color, null)" />
            </btn>
          </container>
          <divider :class="['my-3', 'mx-2']" />
          <container v-for="(lightness, index) in [50, 100, 200, 300, 400, 500, 600, 700, 800, 900]" :key="index" :class="['p-2']">
            <btn block :bold="false" :uppercase="false" size="xs" :bg-color="color" :color="lightness >= 500 ? 'white' : 'black'" :bg-color-lightness="lightness" :title="value">
              <code v-html="label(color, lightness)" />
            </btn>
          </container>
        </flex-col>
      </flex>
      <theme-colors ref="theme-colors" />
    </flex-col>
  </container>
</template>
<script>
export default {
  name: 'ThemeColorsDisplay',
  data () {
    return {
      colors: null
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.colors = this.$refs['theme-colors'].colors
    },
    label (color, lightness) {
      return `${color}${lightness ? ':' + lightness : ' (500)'}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/theme-colors-display.vue